import gql from 'graphql-tag'

import { ChatRoomLastMessageInfo, Message } from '@dinosband/bv-messenger-schema'
import { ClientType } from '@dinosband/bv-apollo-client'
import { _MESSAGE_DATA_PROPERTIES, _MESSAGE_INFO_PROPERTIES } from '../message/const'


export async function queryLastMessages (apollo: ClientType, chatRoomIds: number[], includeProps = true) {
  const dataFields = includeProps ? _MESSAGE_DATA_PROPERTIES : _MESSAGE_INFO_PROPERTIES
  try {
    const result = await apollo.query<{lastMessageInfos: ChatRoomLastMessageInfo[]}>({
      query: gql`query lastMessageInfos($chatRoomIds: [Int]) {
      lastMessageInfos(chatRoomId: $chatRoomIds) {
        ${dataFields}
      }
    }`,
      variables: { chatRoomIds },
      fetchPolicy: 'no-cache',
    })
    return result.data.lastMessageInfos as Message[]
  } catch (e) {
  }
}

export async function queryLastUpdatedMessages (apollo: ClientType, chatRoomIds: number[], includeProps = true) {
  const dataFileds = includeProps ? _MESSAGE_DATA_PROPERTIES : _MESSAGE_INFO_PROPERTIES
  try {
    const result = await apollo.query<{lastUpdatedMessageInfos: ChatRoomLastMessageInfo[]}>({
      query: gql`query lastUpdatedMessageInfos($chatRoomIds: [Int]) {
      lastUpdatedMessageInfos(chatRoomId: $chatRoomIds) {
        ${dataFileds}
      }
    }`,
      variables: { chatRoomIds },
      fetchPolicy: 'no-cache',
    })
    return result.data.lastUpdatedMessageInfos as Message[]
  } catch (e) {
  }
}
